import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import Upload from '../Ui/Upload';
import DropDown from '../Ui/DropDown';
import { toastMessage } from '../../utils/toast';
import { AiOutlineDelete } from "react-icons/ai";
import * as jobActions from '../../Redux/Actions/jobs';
import { useEffect } from 'react';
import { resetFileName } from '../../utils/resetFileName';
import pdfImg from '../../assets/images/pdf_img.png';;

function AdditionalPaymentsModal({ t, showModal, handleCancel, handleOk, loading, options, jobId, footerOption1, footerOption2, additionalPaymentEditData }) {

    const [selectType, setSelectType] = useState('');
    const [referenceNumber, setReferenceNumber] = useState('');
    const [chargeableAmount, setChargeableAmount] = useState('');
    const [attachments, setAttachments] = useState('');
    const [attachmentsId, setAttachmentsId] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [paymentOptions, setPaymentOptions] = useState(options);
    const [updateFlag, setUpdateFlag] = useState(additionalPaymentEditData ? true : false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [note, setNote] = useState('');
    
    useEffect(() => {
        if(additionalPaymentEditData) {
            setUpdateFlag(true);
            let filteredType = options.filter(({value}) => value === additionalPaymentEditData.typeId);
            setPaymentOptions(filteredType);
            const documentIdArr = additionalPaymentEditData?.additionalPaymentAttachment;
            const documentId = documentIdArr[documentIdArr?.length - 1].attachment;
            setAttachmentsId(documentId);
            if(documentId) {
                getDocument(documentId);
            }
            setSelectType(filteredType);
            setChargeableAmount(additionalPaymentEditData.chargeableAmount);
            setReferenceNumber(additionalPaymentEditData.referenceNumber);
            setNote(additionalPaymentEditData?.description);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [additionalPaymentEditData]);

    const getDocument = async (val) => {
        const response = await jobActions.downloadPaymentReceipt(val);
        const { data } = response;
        setAttachments(data);
    }

    const handleUploadAdditionalPayment = (files) => {
        if(!files) {
            return;
        }
        
        setButtonLoading(true);
        let data = new FormData();
        data.append('jobId', jobId);
        data.append('file', resetFileName(files));
        let woExtensionName = files?.name.toLowerCase().split('.');
        if(!(['jpeg', 'jpg', 'pdf', 'png']?.includes(woExtensionName[woExtensionName?.length-1]))) {
            toastMessage('error', 'Un Supported Media type!');
            setButtonLoading(false);
            return;
        } 
        
        setAttachments(files);
        data.append('extension', '.' + woExtensionName[woExtensionName?.length-1]);

        jobActions.uploadPaymentReceipt(data).then(res => {
            if(res && res.data){
                setAttachmentsId(res.data);
            }
            setButtonLoading(false);
        }).catch(err => {
            setButtonLoading(false);
            toastMessage('error', (err?.message) || `Unable to upload the document`);
        });
    };
    
    const handleSubmit = () => {
        if(selectType && referenceNumber && chargeableAmount && attachments) {
            let payload;
            if(updateFlag) {
                payload = {
                    id: additionalPaymentEditData.id,
                    referenceNumber,
                    chargeableAmount,
                    attachment: attachmentsId,
                    description: note
                }
            } else {
                payload = {
                    jobid: jobId,
                    typeId: selectType.value,
                    referenceNumber,
                    chargeableAmount,
                    attachment: attachmentsId,
                    description: note
                }
            }
            
            handleOk(payload, updateFlag);
        } else {
            setErrMsg('Please fill all the inputs!')
        }
    }
    
  return (
    <div>
        <div className="modal" style={{display: (showModal ? 'block': '')}}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{updateFlag ? t("jobsManagement.infoJob.additionalPayment.updateAdditionalPayments"): t("jobsManagement.infoJob.additionalPayment.createAdditionalPayments")}</h5>
                        <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                            <MdClose />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column mb-3">
                            <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.type")}</label>
                            <DropDown value={selectType} placeholder={t("jobsManagement.infoJob.additionalPayment.selectType")} options={paymentOptions} onChange={e => {setSelectType(e); setErrMsg('')}} />
                        </div>
                        <div className="d-flex flex-column mb-3">
                            <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.referenceNumber")}</label>
                            <input placeholder={t("jobsManagement.infoJob.additionalPayment.referenceNumberPlaceholder")} type="text" className="form-control"
                                name="referenceNumber" value={referenceNumber} onChange={e => {setReferenceNumber(e.target.value); setErrMsg('')}} />
                        </div>
                        <div className="d-flex flex-column mb-3">
                            <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.chargeableAmount")}</label>
                            <input placeholder={t("jobsManagement.infoJob.additionalPayment.chargeableAmountPlaceholder")} type="number" className="form-control" 
                                name="referenceNumber" value={chargeableAmount} onChange={e => {setChargeableAmount(e.target.value); setErrMsg('')}} />
                        </div>
                        <div>
                            <p className="text-primary mb-2">{t("jobsManagement.infoJob.additionalPayment.note")}</p>
                            <textarea value={note} onChange={e => setNote(e.target.value)} className="w-100 p-2" rows="4" placeholder={t("jobsManagement.infoJob.additionalPayment.notePlaceholder")}/>
                        </div>
                        <div className="d-flex flex-column mb-3">
                            <label className="form-label mb-1">{t("jobsManagement.infoJob.additionalPayment.attachments")}</label>
                            {/* {attachments && (attachments?.type?.includes('image') ? 
                                <img alt="Document Preview" src={ attachments?.type?.includes('image') ? URL.createObjectURL(attachments): pdfImg} style={{ width: '25%', height: 'auto', margin: '0 0 5px 0' }} /> : 
                                <></>)
                            } */}
                            { attachments && 
                                <img alt="Document Preview"
                                    src={ attachments?.contentType?.includes('image') ? 
                                        (attachments?.contentType?.includes('image') ? `data:image/png;base64,${attachments.content}` : pdfImg):
                                            ((attachments?.type?.includes('image')) ? URL.createObjectURL(attachments) : pdfImg) 
                                        }
                                    style={{ width: '25%', height: 'auto', margin: '0 0 5px 0' }} 
                                />}
                            <div className="d-flex align-items-center">
                                <Upload onChange={e => handleUploadAdditionalPayment(e.target.files[0])} />
                                {attachmentsId && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => {setAttachmentsId(''); setAttachments('')}} />}
                            </div>
                        </div>
                        {errMsg && <p style={{ textAlign: 'center', color: 'red'}}>{errMsg}</p>}
                    </div>
                    <div className="modal-footer">  
                        <button type="button" className="btn btn-light-danger font-weight-bold" disabled={loading} onClick={handleCancel}>{footerOption2 ? footerOption2 : t("jobsManagement.infoJob.createReference.close")}</button>
                        <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || !attachmentsId} onClick={() => handleSubmit()}>{footerOption1 ? footerOption1 : t("jobsManagement.infoJob.createReference.ok")}
                            {(loading || buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop show"></div>
    </div>
  )
}

export default AdditionalPaymentsModal;